export default "__VITE_ASSET__CXb$BK89__"